"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    title: "Propagation Differences",
    cfDns: "Cloudflare DNS",
    gDns: "Google DNS",
    host: "Host",
    XRecords: "({record} Records)",
};
